const SessionSalesCutoffEnum = require('@/lib/Sessions/SessionSalesCutoffEnum');

/**
 * @param {SessionEvent} event
 *
 * @return {function(Session): boolean}
 */
const createSessionSalesCutoffFilterForEvent = (event) => {
    return (session) => {
        const now = new Date();

        // If the session has not started yet it should be visible.
        if (session.startTime.getTime() >= now.getTime()) {
            // Start is not in the past, so we can show.
            return true;
        }

        // This code now uses the settings in the event (eventcats table).
        // There are 3 possible cutoff points for showing the session in the EPOS:
        // 1) session start
        // 2) session end
        // 3) a specific period of time after the session starts
        switch (event.staffSalesCutoffPointAfterSessionStart) {
            // A session_start case is no longer needed, because it's handled above.

            case SessionSalesCutoffEnum.SESSION_END:
                // Cutoff is session end.
                if (session.endTime === null) {
                    // Session has no end time - we don't show these.
                    // (Note we already handled above cases where the session has not started yet.)
                    return false;
                }

                // Return true if end time has not passed.
                return session.endTime.getTime() >= now.getTime();

            case SessionSalesCutoffEnum.SPECIFIC_TIME: {
                const cutoffMillisecondsAfterSessionStart = event.getStaffSalesCutoffTimeInMilliseconds();

                // Return true if start time + cutoff has not passed.
                return session.startTime.getTime() + cutoffMillisecondsAfterSessionStart >= now.getTime();
            }
        }

        return false;
    };
};

module.exports = {
    createSessionSalesCutoffFilterForEvent,
};
